/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadMedication
 */
export interface LeadMedication {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    extracted_medication_name?: string;
    /**
     * 
     */
    extracted_medication_strength?: string;
    /**
     * 
     */
    extracted_medication_frequency?: string;
    /**
     * 
     */
    extracted_medication_route?: string;
    /**
     * 
     */
    extracted_quantity_per_week?: string;
    /**
     * 
     */
    search_terms?: Array<string>;
    /**
     * 
     */
    fdb_dispensable_drug_id?: string;
    /**
     * 
     */
    fdb_packaged_drug_id?: string;
    /**
     * 
     */
    is_generic?: boolean;
    /**
     * 
     */
    fdb_price_swd?: number;
    /**
     * 
     */
    fdb_price_swdpkg?: number;
    /**
     * 
     */
    dispensable_drug_description?: string;
    /**
     * 
     */
    ndc?: string;
    /**
     * 
     */
    j_code?: string;
    /**
     * 
     */
    price_range?: string;
    /**
     * 
     */
    estimated_weekly_cost?: number;
    /**
     * 
     */
    status?: string;
    /**
     * 
     */
    status_reason?: string;
    /**
     * 
     */
    is_non_drug?: boolean;
    /**
     * 
     */
    drug_name_too_broad?: boolean;
    /**
     * 
     */
    fdb_pricing_not_available?: boolean;
    /**
     * 
     */
    received_from_med_list_cache_key?: string;
    /**
     * 
     */
    received_from_similar_drug_cache_key?: string;
    /**
     * 
     */
    deleted_at?: string;
    /**
     * 
     */
    created_at?: string;
}

/**
 * Check if a given object implements the LeadMedication interface.
 */
export function instanceOfLeadMedication(value: object): value is LeadMedication {
    return true;
}

export function LeadMedicationFromJSON(json: any): LeadMedication {
    return LeadMedicationFromJSONTyped(json, false);
}

export function LeadMedicationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadMedication {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'extracted_medication_name': json['extracted_medication_name'] == null ? undefined : json['extracted_medication_name'],
        'extracted_medication_strength': json['extracted_medication_strength'] == null ? undefined : json['extracted_medication_strength'],
        'extracted_medication_frequency': json['extracted_medication_frequency'] == null ? undefined : json['extracted_medication_frequency'],
        'extracted_medication_route': json['extracted_medication_route'] == null ? undefined : json['extracted_medication_route'],
        'extracted_quantity_per_week': json['extracted_quantity_per_week'] == null ? undefined : json['extracted_quantity_per_week'],
        'search_terms': json['search_terms'] == null ? undefined : json['search_terms'],
        'fdb_dispensable_drug_id': json['fdb_dispensable_drug_id'] == null ? undefined : json['fdb_dispensable_drug_id'],
        'fdb_packaged_drug_id': json['fdb_packaged_drug_id'] == null ? undefined : json['fdb_packaged_drug_id'],
        'is_generic': json['is_generic'] == null ? undefined : json['is_generic'],
        'fdb_price_swd': json['fdb_price_swd'] == null ? undefined : json['fdb_price_swd'],
        'fdb_price_swdpkg': json['fdb_price_swdpkg'] == null ? undefined : json['fdb_price_swdpkg'],
        'dispensable_drug_description': json['dispensable_drug_description'] == null ? undefined : json['dispensable_drug_description'],
        'ndc': json['ndc'] == null ? undefined : json['ndc'],
        'j_code': json['j_code'] == null ? undefined : json['j_code'],
        'price_range': json['price_range'] == null ? undefined : json['price_range'],
        'estimated_weekly_cost': json['estimated_weekly_cost'] == null ? undefined : json['estimated_weekly_cost'],
        'status': json['status'] == null ? undefined : json['status'],
        'status_reason': json['status_reason'] == null ? undefined : json['status_reason'],
        'is_non_drug': json['is_non_drug'] == null ? undefined : json['is_non_drug'],
        'drug_name_too_broad': json['drug_name_too_broad'] == null ? undefined : json['drug_name_too_broad'],
        'fdb_pricing_not_available': json['fdb_pricing_not_available'] == null ? undefined : json['fdb_pricing_not_available'],
        'received_from_med_list_cache_key': json['received_from_med_list_cache_key'] == null ? undefined : json['received_from_med_list_cache_key'],
        'received_from_similar_drug_cache_key': json['received_from_similar_drug_cache_key'] == null ? undefined : json['received_from_similar_drug_cache_key'],
        'deleted_at': json['deleted_at'] == null ? undefined : json['deleted_at'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function LeadMedicationToJSON(json: any): LeadMedication {
    return LeadMedicationToJSONTyped(json, false);
}

export function LeadMedicationToJSONTyped(value?: LeadMedication | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'extracted_medication_name': value['extracted_medication_name'],
        'extracted_medication_strength': value['extracted_medication_strength'],
        'extracted_medication_frequency': value['extracted_medication_frequency'],
        'extracted_medication_route': value['extracted_medication_route'],
        'extracted_quantity_per_week': value['extracted_quantity_per_week'],
        'search_terms': value['search_terms'],
        'fdb_dispensable_drug_id': value['fdb_dispensable_drug_id'],
        'fdb_packaged_drug_id': value['fdb_packaged_drug_id'],
        'is_generic': value['is_generic'],
        'fdb_price_swd': value['fdb_price_swd'],
        'fdb_price_swdpkg': value['fdb_price_swdpkg'],
        'dispensable_drug_description': value['dispensable_drug_description'],
        'ndc': value['ndc'],
        'j_code': value['j_code'],
        'price_range': value['price_range'],
        'estimated_weekly_cost': value['estimated_weekly_cost'],
        'status': value['status'],
        'status_reason': value['status_reason'],
        'is_non_drug': value['is_non_drug'],
        'drug_name_too_broad': value['drug_name_too_broad'],
        'fdb_pricing_not_available': value['fdb_pricing_not_available'],
        'received_from_med_list_cache_key': value['received_from_med_list_cache_key'],
        'received_from_similar_drug_cache_key': value['received_from_similar_drug_cache_key'],
        'deleted_at': value['deleted_at'],
        'created_at': value['created_at'],
    };
}

